export default __webpack_public_path__ + "static/5907-7011-Netzteil-da35ba743d62e26012fea98064d8bea9.webp";